module.exports = __webpack_public_path__ + "img/header-background.e98031c3.png";